export default __webpack_public_path__ + "static/media/ellipse_slide_student_two.a332eab3.svg";